import { Select } from 'antd';
import { fetchPlans } from '../apis/plansApi';
import { useEffect, useState } from 'react';

const SelectPlan = ({className = '', onChange, value, include_hidden }) => {

    const [plans, setPlans] = useState([]);
    
    const loadPlans = async () => {
        const branchId = localStorage.getItem('branch_id');
        const plans = await fetchPlans(branchId, include_hidden);
        setPlans(plans)
    };

    useEffect(() => {
        loadPlans()
    }, []);
    
    return (
        <Select
            showSearch
            onChange={onChange}
            value={value}
            placeholder="Plan"
            optionFilterProp="label"
            className={className}
            options={plans?.map(plan => ({
                value: plan.plan_id,
                label: plan.name,
            }))}
        />
    )
}

export default SelectPlan;